import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import HeroSlider from '../components/Home/HeroSlider'
import Abouthome from '../components/Home/Abouthome'
import ProfessionalServices from '../components/Home/ProfessionalServices'
import FreeEstimateBanner from '../components/Home/FreeEstimateBanner'
import WhyEmerald from '../components/Home/WhyEmerald'
import FAQ from '../components/Home/FAQ'
import Footer from '../components/Footer/Footer'
import Contactfooter from '../components/Contactfooter'

const Homepage = () => {
    return (
        <div>
        <Navbar/>
        <HeroSlider/>
        <Abouthome/>
        <ProfessionalServices/>
        <FreeEstimateBanner/>
        <WhyEmerald/>
        <FAQ/>
        <Contactfooter/>
        <Footer/>

        </div>
    )
}

export default Homepage